import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import PatientsGroupsWrapper from './PatientsGroupsWrapper';

loadDOMComponent({
	selector: 'react-patients-groups',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<PatientsGroupsWrapper />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
